var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartner9({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 38,
    viewBox: "0 0 190 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1143",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 190,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 0H0V38H190V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3999 12.9002H49.3999V28.4002H53.0999V12.9002H59.0999V9.7002H43.3999V12.9002Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5001 17.2002H65.4001V9.7002H61.6001V28.3002H65.4001V20.4002H73.5001V28.3002H77.3001V9.80019H73.5001V17.2002Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1 20.3998H92.2V17.3998H84.1V12.9998H93.2V9.7998H80.3V28.3998H93.5V25.1998H84.1V20.3998Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.9 18.6001C114.9 18.2001 116.7 17.0001 116.7 14.3001C116.7 11.6001 114.7 9.6001 111.5 9.6001H103.3V28.2001H111.9C115.1 28.2001 117.5 26.2001 117.5 23.1001C117.3 20.6001 115.5 19.1001 113.9 18.6001ZM106.8 12.7001H110.3C111.9 12.7001 113 13.5001 113 15.1001C113 16.6001 112.1 17.5001 110.5 17.5001H107V12.7001H106.8ZM110.8 25.5001H106.7V20.3001H110.6C112.4 20.3001 113.5 21.2001 113.5 23.0001C113.5 24.6001 112.5 25.5001 110.8 25.5001Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6 9.7998H120V28.3998H132.8V25.0998H123.7V9.7998H123.6Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9 9.6001C137.6 9.6001 133.7 13.3001 133.7 19.1001C133.7 24.9001 137.6 28.5001 142.9 28.5001C148.2 28.5001 152.1 24.8001 152.1 19.0001C152.1 13.2001 148.1 9.6001 142.9 9.6001ZM142.9 25.2001C139.9 25.2001 137.5 22.9001 137.5 19.0001C137.5 15.1001 139.9 12.8001 142.9 12.8001C145.9 12.8001 148.3 15.1001 148.3 19.0001C148.3 22.9001 145.9 25.2001 142.9 25.2001Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 12.8C166 12.8 167.3 14.6 167.7 16.6H171.4C171 12.5 168.4 9.5 163 9.5C157.9 9.5 154.3 13.3 154.3 19C154.3 24.8 158 28.5 163 28.5C168.4 28.5 171 25.5 171.4 21.4H167.7C167.4 23.4 166.2 25.2 163.1 25.2C160.2 25.2 158 22.9 158 19C158 15.2 160.2 12.8 163 12.8Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7 17.7002L189.5 9.7002H185.1L177.5 18.9002V9.7002H173.8V28.3002H177.5V23.4002L180.2 20.4002L185.8 28.4002H190.1L182.7 17.7002Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 36L0.6 29.8C0.1 29.5 0 29.5 0 28.9V8.9C0 8.4 0.1 8.3 0.6 8L15.7 2.2C16.2 2.1 16.3 2.1 16.8 2.2L31.9 8C32.4 8.3 32.5 8.4 32.5 8.9V29C32.5 29.5 32.4 29.6 31.9 29.9L16.8 36C16.3 36.1 16.2 36.2 15.7 36ZM16.2 34.3L29.4 29.1L16.2 24.3L3 29L16.2 34.3ZM1.8 27.7L13.7 23.3L11.5 22.4C11.4 22.3 11.2 22.1 11.2 22V15.8C11.2 15.5 11.3 15.4 11.5 15.4L13.7 14.5L1.8 10V27.7ZM30.7 27.7V10.1L18.8 14.5L21 15.4C21.1 15.5 21.3 15.7 21.3 15.8V22C21.3 22.1 21.2 22.4 21 22.4L18.8 23.3L30.7 27.7ZM16.2 22.3L19.4 21V16.6L16.2 15.3L13 16.6V21L16.2 22.3ZM16.2 13.6L29.4 8.8L16.2 3.7L3 8.7L16.2 13.6Z",
    fill: "#FFE360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8001 8.1L16.7001 2.1C16.6001 2.1 16.3001 2 16.2001 2C16.1001 2 15.8001 2 15.7001 2.1L0.600098 8.1C0.300098 8.1 0.100098 8.5 0.100098 8.9V29C0.100098 29.4 0.400098 29.6 0.600098 29.8L15.5001 35.9C15.6001 35.9 15.9001 36 16.0001 36C16.1001 36 16.4001 36 16.5001 35.9L31.4001 29.8C31.7001 29.7 31.9001 29.4 31.9001 29V8.9C32.3001 8.5 32.0001 8.1 31.8001 8.1ZM16.2001 3.5L29.8001 8.7L16.2001 13.6L2.6001 8.7L16.2001 3.5ZM16.2001 15.2L19.5001 16.6V21.2L16.2001 22.6L12.9001 21.2V16.6L16.2001 15.2ZM1.6001 9.9L14.0001 14.6L11.5001 15.6C11.4001 15.6 11.2001 15.7 11.2001 15.9V22C11.2001 22.1 11.3001 22.3 11.3001 22.3L13.8001 23.3L1.5001 27.9V9.9H1.6001ZM16.2001 34.5L2.7001 29L16.3001 24.1L29.8001 29L16.2001 34.5ZM30.8001 27.9L18.4001 23.3L20.9001 22.3C21.0001 22.3 21.0001 22.2 21.0001 22V15.7C21.0001 15.6 20.9001 15.4 20.9001 15.4L18.4001 14.4L30.8001 9.7V27.9Z",
    fill: "#FFE360"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner9);
export default __webpack_public_path__ + "static/media/partner9.fcbdd80834a090b51137e5bf166e7660.svg";
export { ForwardRef as ReactComponent };